import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from 'pages/Landing';
import AboutUs from 'pages/AboutUs';
import Testimonials from 'pages/Testimonials';
import Gallery from 'pages/Gallery';
import Contact from 'pages/Contact';

// Font Awesome Style Sheet
import '@fortawesome/fontawesome-free/css/all.min.css';

// Tailwind CSS Style Sheet
import 'assets/styles/tailwind.css';

function App() {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/aboutUs" element={<AboutUs />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default App;
